import { Mixins, Prop, Vue, Watch, Component } from 'vue-property-decorator'
import PagedMixin from '@/common/pagination/mixins/paged-mixin'
import ActionGroup from '@/diagrams/models/action-group'

@Component
export default class ActionGroupsTable extends Mixins(PagedMixin) {
  @Prop({ type: Boolean, default: false })
  public loading!: boolean

  @Prop({ default: () => [] })
  public groups!: ActionGroup[]

  public options: any = {}

  get headers() {
    return [
      { text: 'Name', value: 'name' },
      { text: 'Aktionen', value: 'action', sortable: false },
    ]
  }

  private edit(group: ActionGroup) {
    this.$emit('edit', group)
  }

  private deleteGroup(group: ActionGroup) {
    if (confirm('Soll die Maßnahme wirklich gelöscht werden?')) {
      this.$emit('delete', group)
    }
  }
}
